import gsap from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import TextPlugin from "gsap/TextPlugin";
import { GSDevTools } from "gsap/GSDevTools";
import { Flip } from "gsap/Flip";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(
    ScrollTrigger,
    ScrollSmoother,
    DrawSVGPlugin,
    TextPlugin,
    SplitText,
    Flip,
    MorphSVGPlugin,
    ScrollToPlugin,
);

// const smooth = ScrollSmoother.create({
// smooth: 1,
// effects: false, // Enables data-speed and data-lag attributes
// smoothTouch: 1,
// });
// ScrollTrigger.normalizeScroll(true)

export default gsap;

export {
    gsap,
    GSDevTools,
    ScrollTrigger,
    ScrollSmoother,
    SplitText,
    Flip,
};

export function useGSAP() {
    return {
        gsap,
        GSDevTools,
        SplitText,
        ScrollSmoother,
        ScrollTrigger,
        Flip,

    }
}
